module.exports = __webpack_public_path__ + "static/media/16.9b178797.jpeg";